import { inject, signal } from "@angular/core";
import { AuthService } from "./auth.service";
import { TabService } from "../../05_layout/flat-layout/flat-tabs/tab.service";
import { TestingService } from "../../testing.service";

function hasRequiredRole(requiredRoles: string[]): boolean {
    const authService = inject(AuthService);
    const testingService = inject(TestingService);

    const userRoles = authService.roles();
    if(userRoles.some(role => requiredRoles.includes(role))) {
        return true;
    }

    const unauthorizedLabel = signal('Unauthorized');
    if (testingService.layout() === 'mdi') {
        // MDI redirection is handled centrally by the custom MDI router.
    } else {
        const tabService = inject(TabService);
        const activeTab = tabService.getCurrentTab();
        const homeTab = tabService.getHomeTab();
        if (activeTab && homeTab && activeTab.id !== homeTab.id && activeTab.path !== 'unauthorized') {
            tabService.closeWithDescendants(activeTab);
        }
        tabService.activateOrOpen('unauthorized', 'none', unauthorizedLabel, 'Unauthorized', tabService.getHomeTab());
    }

    return false;

}

const ARTICLE_ROLES = ['user', 'art_man', 'art_use'];
export const articleRoleGuard = () => hasRequiredRole(ARTICLE_ROLES);

const APP_ROLES = ['admin', ...ARTICLE_ROLES];
export const appRoleGuard = () => hasRequiredRole(APP_ROLES); // To be extended with roles from other domains
